import { name } from './slice';
import type { INarrativeCard } from './types';

export const getNarrativeCardsList = (state): INarrativeCard[] | undefined =>
  state[name].list;
